<template>
  <div
      class="base-fixed-aside__item-mobile"
      :style="{
        background: background,
        color: color,
      }"
  >
    <FaIcon :icon="itemIcon" />
    <RouterLink
        v-if="link"
        :to="link"
        :target="linkTarget"
    />
  </div>
</template>

<script lang="ts" setup>
import { computed } from 'vue';

const props = withDefaults(defineProps<{
  active?: boolean
  icon?: string
  lable?: string
  link?: string
  linkTarget?: string
  color?: string,
  background?: string
  content?: string
}>(), {
  icon: 'messages-question',
  lable: 'Zu den FAQ',
});

const itemIcon = computed(() => (props.active ? `fa-regular fa-${props.icon}` : `fa-light fa-${props.icon}`));
</script>

<style lang="scss">
@import "../../scss/component-helpers";

.base-fixed-aside__item-mobile {
  position: relative;
  border-radius: 2.5rem;
  height: 2.5rem;
  width: 2.5rem;
  cursor: pointer;
  background: #E7F1F5;
  color: #293033;

  > i, > svg {
    font-size: 1.25rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translateX(-50%) translateY(-50%);
  }

  > a {
    position: absolute;
    inset: 0;
  }
}
</style>
